import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { RouterPath } from './RouterPath';
import Login from '@/pages/login';
import Home from '@/pages/home';
import Dialog from '@/components/dialog';
import Join from '@/pages/join';
import Splash from '@/pages/splash';
import Pin from '@/pages/pin';
import Setting from '@/pages/setting';
import ScrollToTop from '@/components/ScrollTop';
const router = (
  <BrowserRouter>
    <Dialog />
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Splash />} />
      <Route path={RouterPath.LOGIN} element={<Login />} />
      <Route path={RouterPath.JOIN} element={<Join />} />
      <Route path={RouterPath.HOME} element={<Home />} />
      <Route path={RouterPath.PIN} element={<Pin />} />
      <Route path={RouterPath.SETTING} element={<Setting />} />
    </Routes>
  </BrowserRouter>
);

export default router;
